import React, { useEffect } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";

import { track } from "../utils/analytics";
import "../styles/PaymentSuccess.css";   // same styling

function PaymentFailure() {
  const navigate = useNavigate();
  const { user_id } = useParams();
  const [searchParams] = useSearchParams();

  const accountType = searchParams.get("account_type") || "unknown";
  const planId      = searchParams.get("plan")         || "unknown";

  /* ───────── analytics: page view + purchase failure ───────── */
  useEffect(() => {
    track("page_view", {
      page_location: window.location.href,
      page_title   : "Payment Failure",
    });

    track("purchase_failure", {
      account_type: accountType,
      plan_id     : planId,
      reason      : searchParams.get("reason") || "unknown", // supply if available
    });
  }, [accountType, planId, searchParams]);

  /* ───────── redirect after 10s ───────── */
  useEffect(() => {
    const timer = setTimeout(() => {
      const dest =
        accountType === "business"
          ? `/business_plans/${user_id}`
          : `/couples_plans/${user_id}`;

      track("post_payment_redirect", {
        account_type: accountType,
        plan_id     : planId,
        destination : dest,
      });

      navigate(dest);
    }, 10_000);

    return () => clearTimeout(timer);
  }, [navigate, user_id, accountType, planId]);

  /* ───────── render ───────── */
  return (
    <div className="payment-success-container">
      <div
        className="logo"
        onClick={() =>
          track("navigation_click", {
            location   : "payment_failure",
            nav_item   : "Logo",
            destination: "/",
          })
        }
      >
        <a href="/">BestDay2Marry</a>
      </div>

      <div className="payment-message">
        <h1>Payment Failure!</h1>
        <p>Your payment did not go through. Please try again.</p>
        <p>You will be redirected shortly to the payment process.</p>
      </div>

      <div className="spinner" />
    </div>
  );
}

export default PaymentFailure;